import "bootstrap-icons/font/bootstrap-icons.css";
import { AccordionGeneral } from "components/accordion";
import { fraudlist } from "constants/fraudawareness";

function FraudAwareness() {
  return (
    <section className="section about container">
      <div>
        <h1 style={{ color: "#000045", fontWeight: "700" }}>Fraud Awareness</h1>
        <p style={{ color: "#000045" }}>
          For latest Bank Negara Malaysia's information on Consumer Alerts &
          Updates, click 
          <a
            href="https://www.bnm.gov.my/financial-consumer-alert-list"
            target="blank"
          >
            HERE
          </a>
        </p>
      </div>
      <div className="col-12 container">
        <AccordionGeneral list={fraudlist} />
      </div>
    </section>
  );
}

export default FraudAwareness;
